import { parseColorHexRGB } from '@microsoft/fast-colors';
import { SwatchRGB } from '@microsoft/fast-components';
/**
 * The background color swatch.
 * @internal
 * @deprecated - only used in the deprecated ag-theme-material theme
 */
export const backgroundSwatch = SwatchRGB.from(parseColorHexRGB('#4c4c4c'));
/**
 * The foreground color swatch.
 * @internal
 * @deprecated - only used in the deprecated ag-theme-material theme
 */
export const foregroundSwatch = SwatchRGB.from(parseColorHexRGB('#c01754'));
